export enum AgencyName {
  FAIR_SQUARE = 'FAIR_SQUARE',
  BEDROCK = 'BEDROCK',
}
